import { useSession } from '@eneco/auth';
import { useSelfServiceAccount } from '@eneco/auth-be-self-service';
import { getEnecoBeXapiSiteApiV1AccountsByAccountNumberDeliveryAddressesByAddressIdentifierServiceDeliveryPoints } from '@eneco/dc-be/client';
import useAuthenticatedDCBE from '@eneco/dc-be/hooks/useAuthenticatedDCBE';
import unwrapData from '@eneco/dc-be/utils/unwrapData';

import { useAddressOptions } from './useAddressOptions';

export const useServiceDeliveryPoints = () => {
  const { addressIdentifier } = useAddressOptions();
  const {
    selectedAccount: { crmAccountNumber: accountNumber },
  } = useSelfServiceAccount();
  const { data: session } = useSession();

  const { data, isLoading, error } = useAuthenticatedDCBE(
    getEnecoBeXapiSiteApiV1AccountsByAccountNumberDeliveryAddressesByAddressIdentifierServiceDeliveryPoints,
    {
      path: {
        accountNumber,
        addressIdentifier,
      },
      query: {
        includeMetersFromTerminatedAccounts: true,
      },
    },
    [`/accounts/${accountNumber}/delivery-addresses/${addressIdentifier}/service-delivery-points`],
    session,
  );

  return {
    serviceDeliveryPointsData: unwrapData(data),
    isLoading,
    error,
  };
};
